import {Root} from '@radix-ui/react-toggle-group';
import clsx from 'clsx';

type Props = React.ComponentProps<typeof Root> & {
  //
};
export function ToggleGroup({className, ...props}: Props): React.JSX.Element {
  return (
    <Root
      {...props}
      className={clsx(
        'isolate inline-flex flex-col shadow-xs *:not-first:-mt-px *:first:rounded-t-md *:last:rounded-b-md sm:flex-row sm:*:not-first:mt-0 sm:*:not-first:-ml-px sm:*:first:rounded-l-md sm:*:first:rounded-tr-none sm:*:last:rounded-r-md sm:*:last:rounded-bl-none',
        className
      )}
    >
      {props.children}
    </Root>
  );
}

ToggleGroup.displayName = 'ToggleGroup';
